module.exports = __webpack_public_path__ + "img/desktop_goldapple.e4a1c168.png";